import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=35be037f"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35be037f')) {
      api.createRecord('35be037f', component.options)
    } else {
      api.reload('35be037f', component.options)
    }
    module.hot.accept("./FullPage.vue?vue&type=template&id=35be037f", function () {
      api.rerender('35be037f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/full-page/FullPage.vue"
export default component.exports